export type PastePropertyEventDetails = {
  propertyId: number
  assigneeId: string
  payload: string
}
export type PastePropertyEvent = CustomEvent<PastePropertyEventDetails>
export const pastePropertyEventName = 'pasteProperty'
